import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { SessionInfoSingleton } from "../data/singleton/session-info.singleton";
import { map } from "rxjs-compat/operator/map";
import { catchError, tap } from "rxjs/operators";
import { AlertMessage } from "../constants/messages/alert-message";

/**
 * パス「/account_lock」以下のAPIに関するクラス
 */
@Injectable({
  providedIn: "root",
})
export class AccountLockApi {
  /**
   * コンストラクタ
   */
  constructor(private httpClient: HttpClient) {}

  /** UPDATE,PATCH */
  /**
   * アカウントロック
   * - APIパス：/account_lock/${loginId}/${type}
   * @param loginId: ログインID
   * @param type: カウントのインクリメント or カウントリセット、0：リセット／1：インクリメント
   * @returns Observable<Object>型のレスポンス
   */
  accountLock(loginId: string, type: string): Observable<Object> {
    const url = `${environment.apiUrl}/account_lock/${loginId}/${type}`;
    return this.httpClient
      .patch(url, "", {
        headers: new HttpHeaders({
          "x-api-key": environment.apiKey,
          "Content-Type": "application/json",
        }),
      })
      .pipe(
        tap((response) => {
          const jsonStr = JSON.stringify(response);
          const jsonObj = JSON.parse(jsonStr);

          const isLocked = jsonObj.result.account_lock.lock_status;

          if (isLocked == 1) {
            alert(AlertMessage.ACCOUNT_LOCKED_MESSAGE);
          } else if (type == "1") {
            alert(AlertMessage.LOGIN_FAILED_MESSAGE);
          }
        }),
        catchError((error) => {
          if (error.status === 404) {
            alert(AlertMessage.LOGIN_FAILED_MESSAGE);
            return;
          } else {
            alert(AlertMessage.LOGIN_ERROR_MESSAGE);
          }
          return error;
        })
      );
  }
}
